if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      abortController = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();
      }

      get variantSelectors() {
        return this.querySelector("variant-picker");
      }

      get productMedia() {
        return this.querySelector(
          `[id^="MediaGallery-${this.dataset.section}"]`
        );
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }

      get productUrl() {
        return this.dataset.url;
      }

      get productId() {
        return this.getAttribute("data-product-id");
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get inventoryStatus() {
        return this.querySelector(`#Inventory-${this.dataset.section}`);
      }

      get sku() {
        return this.querySelector(`#Sku-${this.dataset.section}`);
      }

      get availability() {
        return this.querySelector(`#Availability-${this.dataset.section}`);
      }

      get enableVariantGroupImages() {
        return this.dataset.enableVariantGroupImages === "true" || false;
      }

      get disableDefaultSelectVariant() {
        return this.dataset.disableDefaultSelectVariant === "true" || false;
      }

      get productForm() {
        return this.querySelector("product-form");
      }

      get quantityInput() {
        return this.querySelector("quantity-input input");
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector(
          "variant-picker [data-selected-variant]"
        )?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      getVariantGroupImages() {
        return (
          JSON.parse(
            this.querySelector('#VariantGroupImages[type="application/json"]')
              .textContent
          ) || {}
        );
      }

      getProductOptionByName(optionName, productData) {
        for (var i = 0; i < productData.options.length; i++) {
          var option = productData.options[i];
          if (option["name"] === optionName) {
            return option;
          }
        }
        return null;
      }

      async getProductData() {
        try {
          const response = await fetch(this.dataset.productUrl + ".js");
          if (!response.ok) {
            throw new Error(
              `Bad HTTP status of the request (${response.status}).`
            );
          }
          const data = await response.json();
          return data;
        } catch (err) {
          console.log(
            `An error occurred while processing the request. Error message: ${err.message}`
          );
        }
      }

      async init() {
        this.swatchProgreeBar()
        this.onVariantChangeUnsubscriber = window.FoxThemeEvents.subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        if (this.enableVariantGroupImages) {
          this.variantGroupImages = this.getVariantGroupImages();
        }

        this.addEventListener("product-media:loaded", (evt) => {
          if (this.enableVariantGroupImages && this.variantGroupImages.enable) {
            this.updateMedia(evt.detail.currentVariant);
          }
        });

        this.productData = await this.getProductData();
        this.Notification = window.FoxTheme.Notification;

        if (this.productData && this.disableDefaultSelectVariant) {
          this.handleDisableDefaultSelectVariant();
        }
      }

      initializeProductSwapUtility() {
        this.postProcessHtmlCallbacks.push((newNode) => {
          __reInitTooltip(newNode);
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      connectedCallback() {
        this.initializeProductSwapUtility();
        this.init();
        // this.cutomChange();

        this.initQuantityHandlers();
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      handleDisableDefaultSelectVariant() {
        const stickyAtc = document.querySelector(".sticky-atc-bar");
        let urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("variant")) return;

        if (stickyAtc) {
          stickyAtc.classList.add("f-hidden");
        }

        this.inventoryStatus && this.inventoryStatus.classList.add("hidden");
        this.sku && this.sku.classList.add("hidden");
        this.availability && this.availability.classList.add("hidden");

        let isVariantChange = false;
        this.pickerFields = this.querySelectorAll("[data-picker-field]");

        this.pickerFields &&
          this.pickerFields.forEach((field) => {
            let optionName = field.dataset.optionName;
            let optionInfo = this.getProductOptionByName(
              optionName,
              this.productData
            );

            if (optionInfo && optionInfo.values.length > 1) {
              isVariantChange = true;
              let pickerType = field.dataset.pickerField;
              switch (pickerType) {
                case "select":
                  let selectBox = field.querySelector("select");
                  let option = document.createElement("option");
                  option.text = this.dataset.variantOptionNoneText;
                  option.setAttribute("disabled", "");
                  option.setAttribute("selected", "");

                  selectBox.add(option, 0);
                  break;
                default:
                  let checkedInputs = field.querySelectorAll("input:checked");
                  checkedInputs &&
                    checkedInputs.forEach(function (input) {
                      input.removeAttribute("checked");
                    });
                  break;
              }

              field.dataset.selectedValue = "";
              if (field.querySelector(".selected-value")) {
                field.querySelector(".selected-value").textContent = "";
              }
            }
          });

        if (isVariantChange) {
          document
            .querySelectorAll(
              `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
            )
            .forEach((productForm) => {
              const input = productForm.querySelector('input[name="id"]');
              input.value = "";
            });

          const atcButton = this.querySelector('[name="add"]');
          const buyNowButton = this.querySelector(
            ".shopify-payment-button__button"
          );

          atcButton.addEventListener(
            "click",
            this.handleDisableDefaultSelectVariantMessage.bind(this)
          );
          buyNowButton &&
            buyNowButton.addEventListener(
              "click",
              this.handleDisableDefaultSelectVariantMessage.bind(this)
            );
        }
      }

      handleDisableDefaultSelectVariantMessage(evt) {
        if (!this.currentVariant) {
          evt.preventDefault();
          this.pickerFields &&
            this.pickerFields.forEach((pickerField) => {
              if ("" === pickerField.dataset.selectedValue) {
                pickerField
                  .closest(".variant-picker__field-wrapper")
                  .classList.add("is-error");
              }
            });

          this.Notification.show({
            target: this.productForm,
            method: "appendChild",
            type: "warning",
            last: 3000,
            message: this.dataset.variantSelectionNeededText,
          });
        }
      }

      cutomChange() {
         document.body.addEventListener("mouseenter", (event) => {
           console.log('hover')
           const swatch = event.target.closest(
              ".swatch__button a:not(.quick-view-swatch)"
            );
  
            if (!swatch) return; // Not one of our target links
            event.preventDefault();
            const handle = swatch.dataset.handle;
           console.log('handle',handle)
         })
        document.body.addEventListener("click", (event) => {
          const swatch = event.target.closest(
            ".swatch__button a:not(.quick-view-swatch)"
          );

          if (!swatch) return; // Not one of our target links
          event.preventDefault();

          const handle = swatch.dataset.handle;
          this.renderProductInfo({
            requestUrl: this.buildRequestUrlWithParams(handle, [], true),
            targetId: null,
            callback: this.handleSwapProduct(handle, true),
          });
        });
      }

      handleOptionValueChange({
        data: { event, target, selectedOptionValues, isSizeSelected },
      }) {
        if (!this.contains(event.target)) return;
        const productUrl =
          target.dataset.productUrl ||
          this.pendingRequestUrl ||
          this.dataset.productUrl;
        const shouldSwapProduct = this.dataset.productUrl !== productUrl;
        const shouldFetchFullPage =
          this.dataset.updateUrl === "true" && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(
            productUrl,
            selectedOptionValues,
            shouldFetchFullPage
          ),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(
                productUrl,
                selectedOptionValues,
                isSizeSelected,
                target
              ),
        });
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          const selector = updateFullPage
            ? "product-info[id^='MainProduct']"
            : "product-info";

          const variant = this.getSelectedVariant(html.querySelector(selector));

          this.updateURL(productUrl, variant?.id);
          if (updateFullPage) {
            const currentShareModal = document.getElementById(
              `PopupModal-Sharing-${this.sectionId}`
            );
            document.querySelector("head title").innerHTML =
              html.querySelector("head title").innerHTML;
            if (currentShareModal) document.body.removeChild(currentShareModal);

            HTMLUpdateUtility.viewTransition(
              document.querySelector("main"),
              html.querySelector("main"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
            HTMLUpdateUtility.viewTransition(
              document.getElementById("shopify-section-sticky-atc-bar"),
              html.getElementById("shopify-section-sticky-atc-bar"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector("product-info"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      handleUpdateProductInfo(
        productUrl,
        _url_params,
        isSizeSelected,
        _target
      ) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          window.FoxThemeEvents.emit(PUB_SUB_EVENTS.variantChange, {
            data: { variant, sectionId: this.sectionId, html },
          });

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateShareUrl(variant?.id);
          this.updateVariantInputs(variant?.id);
          this.toolTip = __reInitTooltip(this);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          // this.updateMedia(variant);

          // const updateSourceFromDestination = (id) => {
          //   const source = html.getElementById(`${id}-${this.sectionId}`);
          //   const destination = this.querySelector(`#${id}-${this.sectionId}`);
          //   if (source && destination) {
          //     destination.innerHTML = source.innerHTML;
          //     destination.removeAttribute("hidden");
          //   }
          // };
          const updateSourceFromDestination = (id) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destinations = this.querySelectorAll(`#${id}-${this.sectionId}`);
            if (source && destinations.length) {
              destinations.forEach((destination) => {
                destination.innerHTML = source.innerHTML;
                destination.removeAttribute("hidden");
              });
            }
          };

          updateSourceFromDestination("Price");
          updateSourceFromDestination("Volume");
          updateSourceFromDestination("PricePerItem");
          updateSourceFromDestination("Inventory");
          updateSourceFromDestination("Sku");
          updateSourceFromDestination("Availability");

          this.updateQuantityRules(this.sectionId, this.productId, html);
          updateSourceFromDestination("QuantityRules");
          updateSourceFromDestination("QuantityRulesCart");
          updateSourceFromDestination("VolumeNote");

          const addButtonUpdated = html.getElementById(
            `ProductSubmitButton-${this.sectionId}`
          );
          this.updateButton(
            addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
            window.FoxThemeStrings.soldOut
          );
          this.currentVariant = variant;
          // if ($(html).find(".f-modal-quickview").length) {
          //   var swatchParent = $(html).find(
          //     ".f-modal-quickview .f-product-quickview__summary"
          //   );
          //   setTimeout(() => {
          //     if (swatchParent.length) {
          //       swatchParent
          //         .find(".swatch__button a")
          //         .addClass("quick-view-swatch");
          //     }
          //   }, 1000);
          // }
          if (html.querySelector(".f-modal-quickview")) {
            const swatchParent = html.querySelector(
              ".f-modal-quickview .f-product-quickview__summary"
            );

            setTimeout(() => {
              if (swatchParent) {
                const links = swatchParent.querySelectorAll(".swatch__button a");
                links.forEach((link) => {
                  link.classList.add("quick-view-swatch");
                });
              }
            }, 1000);
          }
          // console.log('_url_params',_url_params,'isSizeSelected',isSizeSelected)
          if (_url_params.length > 0) {
            if (isSizeSelected == false) {
              if (this.querySelector(`input[data-option-value-id="${_url_params[1]}"]`)) 
              {
                this.querySelector(`input[data-option-value-id="${_url_params[1]}"]`).removeAttribute("checked");
                this.querySelector('.f-product-form__submit span').textContent = 'Select a Size'
              } else {
                if (_target) {
                  _target.setAttribute("checked", true);
                }
              }
            }
            else{
              // console.log('size true taget: ',this.querySelector(`[data-option-name='Size'] .variant-picker__option`))              
              let getOptId = _target.getAttribute('data-option-value-id'),
                newTarget = this.querySelector(`input[data-option-value-id="${getOptId}"]`);
              // console.log('newTarget',newTarget)
              if (newTarget) {
                newTarget.setAttribute("checked", true);
                newTarget.classList.add('size-selected');
              }
            }
          }
          document.dispatchEvent(
            new CustomEvent("variant:changed", {
              detail: {
                variant: this.currentVariant,
              },
            })
          );
        };
      }

      buildRequestUrlWithParams(
        url,
        optionValues,
        shouldFetchFullPage = false
      ) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(",")}`);
        }

        return `${url}?${params.join("&")}`;
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();
        var currentUrl = window.location.href;
        
        // Use the URL constructor to parse it
        const parsedUrl = new URL(currentUrl);
        
        // Get the hostname
        const hostname = parsedUrl.hostname;
        if(currentUrl.includes('products_preview')){
          requestUrl = 'https://' + hostname +  '/products/' + requestUrl         
        }
        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === "AbortError") {
              console.log("Fetch aborted by user");
            } else {
              console.error(error);
            }
          });
      }
      // updateThumb(wrapper, thumb) {
      //   const scrollWidth = wrapper.scrollWidth;
      //   const clientWidth = wrapper.clientWidth;
      //   const scrollLeft = wrapper.scrollLeft;

      //   const thumbWidth = (clientWidth / scrollWidth) * clientWidth;
      //   const maxScroll = scrollWidth - clientWidth;

      //   const scrollProgress = scrollLeft / maxScroll;
      //   const maxThumbMove = clientWidth - thumbWidth;
      //   const thumbX = scrollProgress * maxThumbMove;

      //   thumb.style.width = `${thumbWidth}px`;
      //   thumb.style.transform = `translateX(${thumbX}px)`;
      // }      

      // swatchProgreeBar() {
      //   this.querySelectorAll('.swatch-wrapper').forEach(wrapper => {
      //     const scrollbar = wrapper.nextElementSibling;
      //     if (!scrollbar) return;

      //     const thumb = scrollbar.querySelector('.swatch-scrollbar__thumb');

      //     let isDragging = false;
      //     let startX = 0;
      //     let startScrollLeft = 0;

      //     // Scroll → Thumb
      //     wrapper.addEventListener('scroll', () => this.updateThumb(wrapper, thumb));
      //     window.addEventListener('resize', () => this.updateThumb(wrapper, thumb));

      //     // Drag Start
      //     thumb.addEventListener('touchstart', (e) => {
      //       isDragging = true;
      //       startX = e.touches[0].clientX;
      //       startScrollLeft = wrapper.scrollLeft;
      //     });

      //     thumb.addEventListener('mousedown', (e) => {
      //       isDragging = true;
      //       startX = e.clientX;
      //       startScrollLeft = wrapper.scrollLeft;
      //     });

      //     // Drag Move
      //     document.addEventListener('touchmove', (e) => {
      //       this.handleMove(wrapper, e.touches[0].clientX, isDragging, startX, thumb, startScrollLeft);
      //     });

      //     document.addEventListener('mousemove', (e) => {
      //       this.handleMove(wrapper, e.clientX, isDragging, startX, thumb, startScrollLeft);
      //     });

      //     // Drag End
      //     document.addEventListener('touchend', () => isDragging = false);
      //     document.addEventListener('mouseup', () => isDragging = false);

      //     this.updateThumb(wrapper, thumb);
      //   });
      // }

      handleMove(wrapper, clientX, isDragging, startX, thumb, startScrollLeft) {
        if (!isDragging) return;

        const deltaX = clientX - startX;

        const scrollWidth = wrapper.scrollWidth;
        const clientWidth = wrapper.clientWidth;

        const maxScroll = scrollWidth - clientWidth;
        const maxThumbMove = clientWidth - thumb.offsetWidth;

        const scrollRatio = maxScroll / maxThumbMove;

        wrapper.scrollLeft = startScrollLeft + deltaX * scrollRatio;
      }

      updateThumb(wrapper, thumb) {
        const scrollWidth = wrapper.scrollWidth;
        const clientWidth = wrapper.clientWidth;
        const scrollLeft = wrapper.scrollLeft;

        if (scrollWidth <= clientWidth) {
          thumb.style.width = '0px';
          return;
        }

        const thumbWidth = (clientWidth / scrollWidth) * clientWidth;
        const maxScroll = scrollWidth - clientWidth;
        const scrollProgress = scrollLeft / maxScroll;
        const maxThumbMove = clientWidth - thumbWidth;
        const thumbX = scrollProgress * maxThumbMove;

        thumb.style.transition = 'none';
        thumb.style.width = `${thumbWidth}px`;
        thumb.style.transform = `translateX(${thumbX}px)`;
      }

      swatchProgreeBar() {
        this.querySelectorAll('.swatch-wrapper').forEach(wrapper => {
          const scrollbar = wrapper.nextElementSibling;
          if (!scrollbar) return;

          const thumb = scrollbar.querySelector('.swatch-scrollbar__thumb');

          let isDragging = false;
          let startX = 0;
          let startScrollLeft = 0;

          // ❌ sessionStorage વાળો block હટાવી દો - હવે જરૂર નથી

          wrapper.addEventListener('scroll', () => this.updateThumb(wrapper, thumb));
          window.addEventListener('resize', () => this.updateThumb(wrapper, thumb));

          new ResizeObserver(() => {
            this.updateThumb(wrapper, thumb);
          }).observe(wrapper);

          window.addEventListener('load', () => {
            this.updateThumb(wrapper, thumb);
          });

          thumb.addEventListener('touchstart', (e) => {
            isDragging = true;
            startX = e.touches[0].clientX;
            startScrollLeft = wrapper.scrollLeft;
          });

          thumb.addEventListener('mousedown', (e) => {
            isDragging = true;
            startX = e.clientX;
            startScrollLeft = wrapper.scrollLeft;
          });

          document.addEventListener('touchmove', (e) => {
            this.handleMove(wrapper, e.touches[0].clientX, isDragging, startX, thumb, startScrollLeft);
          });

          document.addEventListener('mousemove', (e) => {
            this.handleMove(wrapper, e.clientX, isDragging, startX, thumb, startScrollLeft);
          });

          document.addEventListener('touchend', () => isDragging = false);
          document.addEventListener('mouseup', () => isDragging = false);

          this.updateThumb(wrapper, thumb);
        });
      }
      updateOptionValues(html) {
        const variantSelects = html.querySelector("variant-picker");
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(
            this.variantSelectors,
            variantSelects,
            this.preProcessHtmlCallbacks
          );
        }
      }

      // updateURL(url, variantId) {
      //   if (this.dataset.updateUrl === "false") return;
      //   window.history.replaceState(
      //     {},
      //     "",
      //     `${url}${variantId ? `?variant=${variantId}` : ""}`
      //   );
      // }
      updateURL(url, variantId) {
        if (this.dataset.updateUrl === "false") return;

        const newUrl = `${url}${variantId ? `?variant=${variantId}` : ""}`;
        // window.history.pushState({}, "", newUrl);

        const stack = JSON.parse(
          sessionStorage.getItem("ajaxHistoryStack") || "[]"
        );
        stack.push(newUrl);
        sessionStorage.setItem("ajaxHistoryStack", JSON.stringify(stack));
      }

      updateShareUrl(variantId) {
        if (!variantId) return;
        const shareButton = document.getElementById(
          `ShareButton-${this.dataset.section}`
        );
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(
          `${window.shopUrl}${this.dataset.url}?variant=${variantId}`
        );
      }

      updateVariantInputs(variantId) {
        document
          .querySelectorAll(
            `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
          )
          .forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = variantId ?? "";
            input.dispatchEvent(new Event("change", { bubbles: true }));
          });
      }

      updateButton(disable = true, text) {
        const productForm = document.getElementById(
          `product-form-${this.sectionId}`
        );
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector(
          '[name="add"] > span:not(.f-icon)'
        );
        if (!addButton) return;
        var isCart = document.body?.classList.contains('template-cart') || false;
        var isQuickUpdate = addButton.dataset.cartId;
        var currenrVariant = productForm.querySelector(`input[name='id']`).value;
        // console.log('cartVariant', cartVariant,'isQuickUpdate',isQuickUpdate)
        const url = new URL(window.location.href);
        const params = url.searchParams;

        if (params.has('size')) {
            params.delete('size');
            const newUrl = url.pathname + (params.toString() ? '?' + params.toString() : '') + url.hash;
            history.replaceState(null, '', newUrl);
        }
        if (disable && isQuickUpdate == undefined) {
          addButton.setAttribute("disabled", "disabled");
          if (text) addButtonText.textContent = text;
        }
        else if(isQuickUpdate != undefined && isCart){
          var cartVariant = document.querySelector('#QuickView-Modal').dataset.variantId;
          if(cartVariant == currenrVariant){
           document.querySelector('#QuickView-Modal').classList.add('quick-update')
             addButtonText.textContent = 'Update';
          }
          else{
            document.querySelector('#QuickView-Modal').classList.remove('quick-update')
            if(disable){
              addButton.setAttribute("disabled", "disabled");
              if (text) addButtonText.textContent = text;
            }
            else{
              addButton.removeAttribute("disabled");
              addButtonText.textContent = 'Update';
            }
          }
        } 
        else {
            addButton.removeAttribute("disabled");
            addButtonText.textContent = window.FoxThemeStrings.addToCart;
        }
      }

      updateMedia(variant) {
        if (!this.productMedia) return;

        if (this.variantGroupImages && this.variantGroupImages.enable) {
          const isCarousel = this.productMedia.querySelector(".flickity-slider")
            ? true
            : false;
          const initalMediaIds = this.productMedia?.domNodes?.medias.map(
            (item) => item.dataset.mediaId
          );
          const groupImages = this.variantGroupImages.mapping.find(
            (item) => Number(item.id) === variant.id
          );
          const currentVariantMedia = groupImages
            ? groupImages.media
            : this.allMediaIds;

          if (!this.areArraysEquivalent(currentVariantMedia, initalMediaIds)) {
            const mainMedia = this.productMedia.querySelector(
              ".f-product__media-list"
            );
            const thumbMedia = this.productMedia.querySelector(
              ".f-product__media-thumbnails"
            );
            if (isCarousel) {
              const mainFlickity = window.FoxTheme.Flickity.data(mainMedia);

              let mediaToRemove =
                mainMedia.querySelectorAll(".f-product__media");
              mediaToRemove &&
                mediaToRemove.forEach(function (slide) {
                  mainFlickity.remove(slide);
                });
              let mediaToShow = this.filteredMediaForSelectedVariant(
                this.productMedia.domNodes.medias,
                currentVariantMedia
              );

              mediaToShow.forEach(function (slide, index) {
                const zoomButton = slide.querySelector(".js-photoswipe--zoom");
                if (zoomButton) {
                  zoomButton.setAttribute("data-media-index", index);
                }
                slide.setAttribute("data-media-index", index);
                slide.setAttribute("data-index", index);
                mainFlickity.append(slide);
              });

              if (thumbMedia && this.productMedia.domNodes.thumbnailItems) {
                const thumbnailsFlickity =
                  window.FoxTheme.Flickity.data(thumbMedia);

                let thumbsToRemove = thumbMedia.querySelectorAll(
                  ".f-product__media-thumbnails-item"
                );
                thumbsToRemove &&
                  thumbsToRemove.forEach(function (slide) {
                    thumbnailsFlickity.remove(slide);
                  });

                let thumbsToShow = this.filteredMediaForSelectedVariant(
                  this.productMedia.domNodes.thumbnailItems,
                  currentVariantMedia
                );
                thumbsToShow.forEach(function (slide, index) {
                  slide.setAttribute("data-thumbnail-index", index);
                  slide.setAttribute("data-index", index);
                  thumbnailsFlickity.append(slide);
                });

                thumbMedia.classList.remove(
                  "disable-transition",
                  "md:disable-transition"
                );
                if (thumbsToShow.length < 5) {
                  thumbMedia.classList.add("disable-transition");
                }
                if (thumbsToShow.length < 6) {
                  thumbMedia.classList.add("md:disable-transition");
                }
                thumbnailsFlickity.option({
                  wrapAround: thumbsToShow.length > 5,
                });
                thumbnailsFlickity.reloadCells();
                thumbnailsFlickity.reposition();
              }

              mainFlickity.select(0, false, false);
            } else {
              let mediaToShow = this.filteredMediaForSelectedVariant(
                this.productMedia.domNodes.medias,
                currentVariantMedia
              );
              mainMedia.innerHTML = "";
              mediaToShow.forEach((item, index) => {
                const zoomButton = item.querySelector(".js-photoswipe--zoom");
                if (zoomButton) {
                  zoomButton.setAttribute("data-media-index", index);
                }
                item.setAttribute("data-media-index", index);
                item.setAttribute("data-index", index);
                mainMedia.append(item);
              });
            }

            // Re-init Photoswipe
            if (this.productMedia && this.productMedia.enableZoom) {
              this.productMedia.lightbox &&
                this.productMedia.lightbox.destroy();
              this.productMedia.initImageZoom();
            }
          }

          this.productMedia.removeAttribute("data-media-loading");
        } else {
          if (!variant.featured_media) return;
          if (typeof this.productMedia.setActiveMedia === "function") {
            this.productMedia.setActiveMedia(variant.featured_media.id);
          }
        }
      }

      setUnavailable() {
        const button = document.getElementById(
          `product-form-${this.sectionId}`
        );
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector(
          '[name="add"] > span:not(.f-icon)'
        );
        if (addButton) {
          addButtonText.textContent = window.FoxThemeStrings.unavailable;
        }

        const selectors = [
          "Price",
          "Inventory",
          "Sku",
          "PricePerItem",
          "VolumeNote",
          "Volume",
          "QuantityRules",
          "QuantityRulesCart",
        ]
          .map((id) => `#${id}-${this.sectionId}`)
          .join(", ");
        document
          .querySelectorAll(selectors)
          .forEach((selector) => selector.setAttribute("hidden", ""));
      }

      areArraysEquivalent(firstArray, secondArray) {
        if (!Array.isArray(firstArray) || !Array.isArray(secondArray)) {
          return false;
        }

        if (firstArray.length !== secondArray.length) {
          return false;
        }

        const sortedFirstArray = [...firstArray].sort();
        const sortedSecondArray = [...secondArray].sort();

        return sortedFirstArray.every(
          (value, index) => value === sortedSecondArray[index]
        );
      }

      filteredMediaForSelectedVariant(items, currentVariantMedia) {
        let index = 0;
        let prioritizedResults = [];
        let otherResults = [];
        items.forEach((item) => {
          const dataIdMedia = item.dataset.mediaId;
          if (currentVariantMedia && currentVariantMedia.length > 0) {
            if (currentVariantMedia.includes(dataIdMedia)) {
              item.dataset.index = index++;
              prioritizedResults.push(item);
            }

            if (item.dataset.mediaType !== "image") {
              item.dataset.index = index++;
              otherResults.push(item);
            }
          } else {
            item.dataset.index = index++;
            prioritizedResults.push(item);
          }
        });

        const sortByVariantOrder = (a, b) => {
          const indexA = currentVariantMedia.indexOf(a.dataset.mediaId);
          const indexB = currentVariantMedia.indexOf(b.dataset.mediaId);
          return indexA - indexB;
        };

        prioritizedResults.sort(sortByVariantOrder);

        const results = [...prioritizedResults, ...otherResults];

        return results;
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.setQuantityBoundries();
        if (!this.hasAttribute("data-original-section-id")) {
          this.cartUpdateUnsubscriber = FoxThemeEvents.subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
      }

      setQuantityBoundries() {
        FoxThemeEvents.emit(PUB_SUB_EVENTS.quantityBoundries, {
          data: {
            sectionId: this.sectionId,
            productId: this.productId,
          },
        });
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        fetch(
          `${this.getAttribute(
            "data-product-url"
          )}?variant=${currentVariantId}&section_id=${this.sectionId}`
        )
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.updateQuantityRules(
              this.sectionId,
              this.productId,
              parsedHTML
            );
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {});
      }

      updateQuantityRules(sectionId, productId, parsedHTML) {
        if (!this.quantityInput) return;

        FoxThemeEvents.emit(PUB_SUB_EVENTS.quantityRules, {
          data: {
            sectionId,
            productId,
            parsedHTML,
          },
        });

        this.setQuantityBoundries();
      }
    }
  );

  const currentUrl = window.location.pathname + window.location.search;

  const prefetchCache = {};
  const fetchPromises = {};
  
  document.body.addEventListener("mouseover", async (event) => {
    const swatch = event.target.closest(
      ".swatch__button a:not(.quick-view-swatch)"
    );
    if (!swatch) return;
  
    const handle = swatch.dataset.handle;
    if (prefetchCache[handle] || fetchPromises[handle]) return;
  
    // Store ongoing fetch as a promise
    fetchPromises[handle] = fetch(handle)
      .then((response) => response.text())
      .then((html) => {
        prefetchCache[handle] = html;
        delete fetchPromises[handle];
      })
      .catch((err) => {
        console.error("Prefetch error:", err);
        delete fetchPromises[handle];
      });
  });
  
  document.body.addEventListener("click", async (event) => {
  const swatch = event.target.closest(
    ".swatch__button a:not(.quick-view-swatch)"
  );
  if (!swatch) return;

  event.preventDefault();
  const handle = swatch.dataset.handle;

  // ✅ SWAP પહેલા scroll position save કરો
  const swatchWrapper = swatch.closest('.swatch-wrapper');
  const savedScrollLeft = swatchWrapper ? swatchWrapper.scrollLeft : 0;

  if (fetchPromises[handle]) {
    await fetchPromises[handle];
  }

  const html = prefetchCache[handle];
  if (!html) {
    console.warn("HTML not available for handle:", handle);
    return;
  }
  
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  const newNodeWrapper = document.createElement("div");
  setInnerHTML(newNodeWrapper, html);

  const newMain = newNodeWrapper.querySelector("main");
  const oldMain = document.querySelector("main");
  if (!newMain || !oldMain) return;

  HTMLUpdateUtility.viewTransition(
    document.getElementById("shopify-section-sticky-atc-bar"),
    doc.getElementById("shopify-section-sticky-atc-bar"),
    this.preProcessHtmlCallbacks,
    this.postProcessHtmlCallbacks
  );

  const uniqueKey = Date.now();
  oldMain.querySelectorAll("[id], [form]").forEach((element) => {
    if (element.id) element.id = `${element.id}-${uniqueKey}`;
    if (element.form) {
      const formId = element.getAttribute("form");
      if (formId) element.setAttribute("form", `${formId}-${uniqueKey}`);
    }
  });

  oldMain.innerHTML = newMain.innerHTML;
  setInnerHTML(oldMain, newMain.innerHTML);

  // ✅ DOM replace થયા પછી INSTANTLY scroll restore કરો - no RAF delay
  oldMain.querySelectorAll('.swatch-wrapper').forEach(wrapper => {
    wrapper.style.scrollBehavior = 'auto';
    wrapper.scrollLeft = savedScrollLeft;
    wrapper.style.scrollBehavior = '';
  });

  if (window.patchBreadcrumbCollection) window.patchBreadcrumbCollection();
  if (window.Foxtheme && Foxtheme.jmReload) Foxtheme.jmReload();

  if (handle) {
    const url = new URL(handle, window.location.origin);
    window.history.replaceState(null, '', '/products' + url.pathname + url.search);
  }
  
  setTimeout(() => {
    try {     
      addFitSelector();   
      addCustomButtons();
      Nosto.reloadCart();
    } catch (error) {
      console.log('Nosto cart change ', error);
    }
  }, 500);
});
  
  function setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll("script").forEach((oldScriptTag) => {
      const newScriptTag = document.createElement("script");
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(
        document.createTextNode(oldScriptTag.innerHTML)
      );
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    });
  }

  function extractHandleFromUrl(url) {
    const match = url.match(/\/products\/([^/?#]+)/);
      return match ? match[1] : null;
  }

  window.addEventListener("popstate", async () => {
    const path = window.location.pathname;

    // Check if it's a product page
    if (!path.startsWith("/products/")) {
      window.location.href = path; // Fallback for non-product paths
      return;
    }

    const handle = path.split("/products/")[1].split("/")[0];

    // If cache exists for this product, use it
    if (prefetchCache[handle]) {
      const html = prefetchCache[handle];
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const newMain = doc.querySelector("main");
      const oldMain = document.querySelector("main");

      if (newMain && oldMain) {
        const uniqueKey = Date.now();
        oldMain.querySelectorAll("[id], [form]").forEach((element) => {
          if (element.id) element.id = `${element.id}-${uniqueKey}`;
          if (element.form) {
            const formId = element.getAttribute("form");
            if (formId) element.setAttribute("form", `${formId}-${uniqueKey}`);
          }
        });

        oldMain.innerHTML = newMain.innerHTML;
        setInnerHTML(oldMain, newMain.innerHTML);
        if (window.Foxtheme && Foxtheme.jmReload) Foxtheme.jmReload();
      }

      // Update ATC bar if needed
      const oldSticky = document.getElementById("shopify-section-sticky-atc-bar");
      const newSticky = doc.getElementById("shopify-section-sticky-atc-bar");
      if (oldSticky && newSticky) {
        HTMLUpdateUtility.viewTransition(
          oldSticky,
          newSticky,
          this?.preProcessHtmlCallbacks,
          this?.postProcessHtmlCallbacks
        );
      }

    } else {
      // If not cached, do a full reload
      window.location.href = path;
    }
  });

}